module.exports = __webpack_public_path__ + "media/images/social/vk-ce32245f1f1f3c91757858f97b76620c.svg";